@if (viewModel$ | async; as vm) {
    <form class="state-scope" [class.loading]="loadingSchools" [formGroup]="vm.formlyForm">
        <formly-form [form]="vm.formlyForm" [model]="vm.formlyModel" [fields]="vm.formlyFields"></formly-form>
        <tdoe-button size="small" class="btn-inline" text="Apply" [disabled]="vm.formlyForm.invalid || loadingSchools" (click)="onSearchClick(vm)"></tdoe-button>
        <tdoe-button size="small" class="btn-inline" text="Reset" (click)="onResetClick(vm)"></tdoe-button>
    </form>
    
}